import { create } from 'zustand';
import { getAllDevicesApi } from '../../../api/api';

export const useControllersStore = create((set) => ({
  data: [],
  isLoading: false,
  error: null,
  total: 0,

  fetchControllers: async ({ page, limit, serialId, typeKey } = {}) => {
    set({ isLoading: true, error: null });

    await getAllDevicesApi({
      page,
      count: limit,
      serial_id: serialId,
      type_key: typeKey,
      dataCb: (data) => {
        set({ data: data?.items || [], total: data?.count || 0, isLoading: false });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
}));
